import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, shareReplay, tap} from 'rxjs';
import {environment} from '../../environments/environment';
import {AuthResult} from '../models/Auth/AuthResult';
import moment from 'moment';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from "./user.service";
import {User} from "../models/User/User";
import {toSignal} from "@angular/core/rxjs-interop";


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  apiUrl = environment.api + 'auth/SiteClient/';
  apiGccUrl = environment.api + 'bff/';

  userAuth$ = new BehaviorSubject<User | null>(null);

  userAuthObservable$ = this.userAuth$.asObservable();

  userLanguage$ = new BehaviorSubject<string | null>(null);

  s_userAuth = toSignal(this.userAuthObservable$);

  constructor(private http: HttpClient, private router: Router, private userService: UserService, private route : ActivatedRoute) {
//   this.userAuthObservable$ = this.userAuth$.pipe(map( (x: User| null)  => this.loadUser(x)));
    this.loadInitialUser();
  }

  private loadInitialUser() {
    if (this.isLoggedIn()) {
      this.userService.getMe().then(user => {
        this.userAuth$.next(user);
        this.userLanguage$.next(user?.langue_Extranet ?? null);
      });
    }
  }

  login(user: string, password: string) {

    const fd = new FormData();
    fd.append('user', user);
    fd.append('password', password);
    fd.append('userAgent', navigator.userAgent);
    return this.http.post<AuthResult>(this.apiUrl + 'Login', fd).pipe(
      tap(async (res) => {
        this.setAuth(res);

        const user = await this.userService.getMe();
        if (user) {
          this.userAuth$.next(user);
          this.userLanguage$.next(user.langue_Extranet ?? null);
       
          //this.logConnexionSiteClient(user.idContact,navigator.userAgent)

          const lang = user.langue_Extranet === 'fr-FR' ? 'fr' : 'en';
          const baseUrl = environment.url;

          // Récupérer le paramètre redirectTo
          const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo');

          if (redirectTo) {
            const decodedRedirectTo = decodeURIComponent(redirectTo);
            window.location.href = `${baseUrl}${lang}/${decodedRedirectTo}`;
          } else {
            window.location.href = `${baseUrl}${lang}/`;
          }
        }
      }),
      shareReplay(1)
    );

  }




  forgotPassword(email: string) {
    //TODO handle reset password
    console.log(email)
  }

  setAuth(authResult: AuthResult) {

    const expiration_date = new Date();
    expiration_date.setUTCSeconds(expiration_date.getSeconds() + authResult.expire_in);
    localStorage.setItem('token', authResult.token);
    localStorage.setItem("expiration_time", JSON.stringify(authResult.expire_in));
    localStorage.setItem("expiration", moment(expiration_date).format('YYYY-MM-DDTHH:mm:ss').toString());
    localStorage.setItem("user_name", authResult.userName);
    localStorage.setItem("user_id", this.parseJwt(authResult.token).nameid);
  }

  // loadUser(x: User | null) {
  //   if (this.isLoggedIn()) {
  //     if (!x) {
  //       this.userService.getMe().then(u => this.userAuth$.next(u));
  //       return null;
  //     } else {
  //       return x;
  //     }
  //   }
  //   return null;
  // }

  public isLoggedIn() {
    const tokenStorage = localStorage.getItem('token');
    if (tokenStorage) {
      const expiration = localStorage.getItem('expiration');
      return moment().isBefore(expiration);
    } else {
      return false;
    }
  }

  async logout() {
    localStorage.clear();
    await this.router.navigate(['/login']);
  }

  getExpiration() {
    const expirationDate = localStorage.getItem('expiration');
    return expirationDate!;
  }

  parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  prixPrefUser(prix: number, nb_Bouteille_Caisse?: string) {

    const userAuth = this.s_userAuth();
    if(userAuth){
      if(userAuth.unite_Extranet === 'CS' && nb_Bouteille_Caisse){
        // CAISSE
        return prix * parseInt(nb_Bouteille_Caisse)
      } else {
        // BTL
        return prix
      }
    }
    else {
      return prix;
    }

  }
}
